module.exports = __webpack_public_path__ + "static/media/carousel_banner_1.a7f2f575.png";